import { IconLoader } from 'common/IconLoader';

export const alarmSeverity = {
  CRITICAL: 0,
  MAJOR: 1,
  MINOR: 2,
  WARNING: 3,
  INFO: 4,
  UNKNOWN: 5
};

export const deviceTypeToIcon = {
  'Echo 5G': IconLoader.icon_echo,
  'Pivot 5G Donor': IconLoader.icon_donor,
  'Pivot 5G Service': IconLoader.icon_service
};

export const getTrimmedString = (deviceId, maxLength) => {
  if (deviceId.length > maxLength) {
    return deviceId.substr(0, maxLength - 3) + '...';
  }

  return deviceId;
};
